"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProduct = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var hooks_1 = require("../../../hooks");
var actions_1 = require("../../../store/product/actions");
require("./style.scss");
exports.SearchProduct = react_1.default.memo(function (_a) {
    var dish = _a.dish;
    var setFilters = (0, hooks_1.useSetFilters)();
    var id = dish.id, photoBigThumb = dish.photo_big_thumb, photo = dish.photo, price = dish.price;
    var dispatch = (0, react_redux_1.useDispatch)();
    var currency = (0, react_redux_1.useSelector)(function (state) { var _a; return (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.currency; });
    var onOpenProduct = function () {
        setFilters({ product: id, basketProduct: '' });
        dispatch((0, actions_1.addProduct)(dish));
    };
    var dishAllergens = dish.allergens.map(function (allergen) { return allergen.name; }).join(',');
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "search-product", onClick: onOpenProduct }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "search-product-image" }, { children: (0, jsx_runtime_1.jsx)("img", { alt: dish.title || '', src: photoBigThumb !== null && photoBigThumb !== void 0 ? photoBigThumb : photo }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "search-product-info" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "search-product-info-title" }, { children: [dish.title, dishAllergens.length > 0 ? "(".concat(dishAllergens, ")") : ''] })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "search-product-info-description" }, { children: dish.description })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "search-product-info-price" }, { children: [currency.title, price === null || price === void 0 ? void 0 : price.toFixed(2)] }))] }))] })));
});
